export const defaultProductFields = [
  {
    fieldKey: 'image',
    label: '',
    type: 'image',
  },
  {
    fieldKey: 'best_for',
    label: 'Good Fit For',
  },
  {
    fieldKey: 'rating',
    label: 'Rating',
  },
  {
    fieldKey: 'review',
    label: 'Read Review',
    type: 'reviewLink',
  },
];

export const additionalProductFields = [
  {
    fieldKey: 'details',
    label: 'Pros',
    subfield: 'pros',
    type: 'pros',
  },
  {
    fieldKey: 'details',
    label: 'Cons',
    subfield: 'cons',
    type: 'cons',
  },
  {
    fieldKey: 'link',
    hideLabel: true,
    label: 'Get Started',
    type: 'link',
  },
];
